import { imageRefZodSchema } from "@@/shared/images/image-ref";
import { priceZodSchema } from "@@/shared/prices/price";
import { hexColorZodSchema } from "@@/shared/stylable/hex-color/hex-color";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";
import { contentIdZodSchema } from "../../../content/content-id";
import { blockContentIdZodSchema } from "./block-content-id";

const _blockContentBaseZodObject = z.object({
    _id: blockContentIdZodSchema,
    _type: z.literal("BLOCK_CONTENT"),
    title: translatableZodSchema,
    subtitle: translatableZodSchema,
    kicker: translatableZodSchema.optional(),
    /**
     * optional; falls back to item defaults if not provided
     */
    actionText: translatableZodSchema,
    inactive: z.boolean(),
    tags: z.array(z.string()),
    poster: imageRefZodSchema.optional(),
    backgroundColor: z.string().optional(),
    contentId: contentIdZodSchema,
    contentType: z.enum(["PRODUCT", "PAGE", "CUSTOM"]),
});
const productBlockContentZodObject = _blockContentBaseZodObject.merge(
    z.object({
        price: priceZodSchema.optional(),
        contentType: z.literal("PRODUCT"),
    }),
);
type BlockContent_Product = z.infer<typeof productBlockContentZodObject>;
const pageBlockContentZodObject = _blockContentBaseZodObject.merge(
    z.object({
        contentType: z.literal("PAGE"),
    }),
);
type BlockContent_Page = z.infer<typeof pageBlockContentZodObject>;
const customContentBlockContentZodObject = _blockContentBaseZodObject.merge(
    z.object({
        contentType: z.literal("CUSTOM"),
        url: z.string().url().optional(),
        textColor: hexColorZodSchema.optional(),
        accentColor: hexColorZodSchema.optional(),
    }),
);
type BlockContent_CustomContent = z.infer<
    typeof customContentBlockContentZodObject
>;

const _blockContentZodObject = z.discriminatedUnion("contentType", [
    productBlockContentZodObject,
    pageBlockContentZodObject,
    customContentBlockContentZodObject,
]);

type BlockContent = z.infer<typeof _blockContentZodObject>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isBlockContent = (input: any): input is BlockContent => {
    return input._type === "BLOCK_CONTENT";
};
export { isBlockContent };
export type {
    BlockContent,
    BlockContent_CustomContent,
    BlockContent_Page,
    BlockContent_Product,
};
